import { Suspense } from "react";

import LoadingIndicatorFullPage from "../../../cc-ui/components/LoadingIndicator/LoadingIndicatorFullPage";
import { AIChatPage } from "./AIChatPage";

export const AIChatPageAsync = () => {
  return (
    <Suspense fallback={<LoadingIndicatorFullPage open />}>
      <AIChatPage />
    </Suspense>
  );
};
